var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 8,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 29.5L25 25.5L21 29.5",
    stroke: "#065EEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.5V34.5",
    stroke: "#065EEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3904 31.89C34.3658 31.3583 35.1363 30.5169 35.5803 29.4986C36.0244 28.4804 36.1167 27.3432 35.8427 26.2667C35.5686 25.1901 34.9439 24.2355 34.0671 23.5534C33.1903 22.8714 32.1113 22.5007 31.0004 22.5H29.7404C29.4378 21.3292 28.8736 20.2423 28.0904 19.321C27.3072 18.3996 26.3253 17.6678 25.2185 17.1806C24.1118 16.6933 22.909 16.4633 21.7006 16.5079C20.4921 16.5524 19.3095 16.8703 18.2416 17.4376C17.1737 18.005 16.2484 18.8071 15.5351 19.7836C14.8218 20.76 14.3391 21.8855 14.1234 23.0754C13.9077 24.2652 13.9646 25.4885 14.2897 26.6532C14.6148 27.818 15.1997 28.8939 16.0004 29.8",
    stroke: "#065EEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29.5L25 25.5L21 29.5",
    stroke: "#065EEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherUploadCloud);
export default __webpack_public_path__ + "static/media/feather_upload-cloud.54c6ea5cdb79bbe4d9e8b56828aaf689.svg";
export { ForwardRef as ReactComponent };